import { getConfig } from './config'
import { LoginResponse } from './login'

export type ValidateEmail = {
  email: string;
  captcha?: string;
  planId?: string;
  code?: string;
}

export type ValidateEmailResponse = {
  validationChecker: string;
}

export type Register = {
  validationChecker: string;
  token: string;
  email: string;
  phone: string;
  name: string;
  password: string;
  zipCode: string;
  occupation: string;
  birthDate: Date;
  captcha?: string;
  code?: string;
}

export type RegisterSocial = {
  captcha?: string;
  type: 'facebook' | 'google';
  accessToken: string;
  phone?: string;
  occupation: string;
  code?: string;
}

export const validateEmail = async ({ email, ...restParams }: ValidateEmail): Promise<ValidateEmailResponse> => {
  const config = getConfig()
  const response = await config.axios.post<ValidateEmailResponse>(`${config.API_URL}/auth/validate-email`, {
    email,
    ...restParams
  })

  return response.data
}

export const register = async (register: Register): Promise<LoginResponse> => {
  const config = getConfig()
  const response = await config.axios.post<LoginResponse>(`${config.API_URL}/auth/register`, register)

  return response.data
}

export const registerSocial = async (register: RegisterSocial): Promise<LoginResponse> => {
  const config = getConfig()
  const response = await config.axios.post<LoginResponse>(`${config.API_URL}/auth/register/social`, register)

  return response.data
}
